// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"4c892312","247":"1d533b67","422":"33636bd2","627":"62bff105","768":"8031b8d7","806":"06b88cd6","834":"231565a1","923":"c6cd312f","938":"6fe9908e"}[chunkId] + ".chunk.js";
};